import { render } from "./DefaultPayment.vue?vue&type=template&id=ae373276"
import script from "./DefaultPayment.vue?vue&type=script&lang=js"
export * from "./DefaultPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__